export default class Language {
  public id!: string;
  public name !: string;
  public level !: string;
  public importance !: number;
}